export default "__VITE_ASSET__BxAJ0cPq__"